import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { recipesStatsQuery } from '@/api'
import RecipeStats from '@/features/recipes/RecipesStats/RecipesStats'
import { RecipesSearch } from './recipes'
import { ExpertiseLevel } from '@/features/recipes/constants'

export const Route = createFileRoute('/recipes/stats')({
  loaderDeps: ({ search }) => ({
    ...search,
  }),
  loader: async ({ context: { queryClient }, deps }) => {
    const [response] = await Promise.all([queryClient.ensureQueryData(recipesStatsQuery(deps))])

    return {
      data: response.data,
    }
  },
  component: StatsComponent,
  validateSearch: (search: Record<string, unknown>): RecipesSearch => {
    // validate and parse the search params into a typed state
    return {
      tagName: search.tagName as string[],
      authorId: search.authorId as number,
      suitableDiet: search.suitableDiet as string[],
      suitableFoodRestrictionID: search.suitableFoodRestrictionID as string[],
      cuisine: search.cuisine as string,
      expertiseLevel: search.expertiseLevel as ExpertiseLevel[],
    }
  },
})

function StatsComponent() {
  const { data } = Route.useLoaderData()

  return <RecipeStats statistics={data} />
}
